import React from 'react'

const UnsupportedView = () => (
  <div>This browser is uncapable of recording video</div>
)

export default UnsupportedView
